import LandingApps from 'components/LandingApps/LandingApps'

export default LandingApps
